<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="217.91" height="136.68" viewBox="0 0 217.91 136.68">
        <g id="Capa_2" data-name="Capa 2">
            <g id="Capa_1-2" data-name="Capa 1">
                <g>
                    <path class="cls-1" d="M182.21,101.37a.53.53,0,0,1,.22,0c.5.27.95.09,1-.38s-.53-.64-.86-.59c-1,.15-2-.39-3-.35.58-.67,1.29-.23,1.94-.25a49.32,49.32,0,0,1,12.8,2.28c.55.16,1.06.29,1.12,1.18.05.73,2.13,1.42,3,1.19.28-.07.49-.21.74,0a6.26,6.26,0,0,0,2.86,1.41,23.22,23.22,0,0,1,8.52,5.18c.38.34.64.89,1.39.59.38-.15.68.28.79.71a1.87,1.87,0,0,0,1.4,1.48c.69.22,1.72.73,1.6,1.91a.52.52,0,0,0,.22.38,5.35,5.35,0,0,1,1.94,2.6v1.68a24.14,24.14,0,0,0-4.14,4.81c-1.76,2.56-4.52,3.83-7.32,5a35.21,35.21,0,0,1-5,1.87c-2,.46-3.86,1.48-5.81,1.67-3.62.36-7.08,1.51-10.69,1.73a19.62,19.62,0,0,1-4.15-.46,27.56,27.56,0,0,0-4.06-.22c-1.11,0-2.25.27-3.23-.68-.44-.42-1.21-.29-1.85-.28a9,9,0,0,1-4.85-.95,7.36,7.36,0,0,0-2.44-.5c-2.14-.36-4-1.58-6-2.27-2.75-.95-5.31-2.36-8-3.35a7.71,7.71,0,0,1-3-2.49c-1.51-1.75-2.06-1.88-4.15-1.17-.26.11-.3,0-.26-.24l.92-.85c-.65-.43-1.1-.06-1.54.23a10.84,10.84,0,0,0-1.44,1,9.17,9.17,0,0,1-4.89,2,3.64,3.64,0,0,0-2.43,1.62,10.1,10.1,0,0,1-2.8,2.57c-.57.41-1.28.69-1.5,1.47a.3.3,0,0,1-.45.22c-.91-.45-1,.49-1.51.7.37.6,1.12.21,1.34.78a.87.87,0,0,1-.06.13c-2.49-.47-4.3.94-6.16,2.23-.79.54-1.67.94-2.48,1.44s-1.17-.09-1.55-.64c-.85-1.25-.17-2.16.68-3.05a25,25,0,0,1,3.21-2.69,1.36,1.36,0,0,0,.57-1.83,2.89,2.89,0,0,1,1-3.13c.17-.12.44-.28.53-.09.51,1,1.2.22,1.57,0,4.38-2.38,8.82-4.65,13-7.38.62-.41.61-.7.17-1.17-.78-.84-1.51-1.74-2.36-2.49-.38-.34-.79-.74-.8-1.12-.05-1.54-1.06-2.19-2.23-2.82a2.81,2.81,0,0,1-1.72-1.84c-.32-1.07-1.55-2-2.53-2.87a13,13,0,0,1-4.12-6.57,5.23,5.23,0,0,1-.15-1.18c0-1.13.16-1.22,1.09-.71a2.23,2.23,0,0,0,.57.18c5.17,1.38,9.37,4.32,13.13,8a30.14,30.14,0,0,0,6.21,5.22c.28.16.57.3.85.45a2.62,2.62,0,0,0,3.06-.17,35.86,35.86,0,0,1,5.83-3.52,44.82,44.82,0,0,1,11-3.36,63.4,63.4,0,0,1,15.38-.78,47.07,47.07,0,0,1,7.09,1.09,5.66,5.66,0,0,0,.82.16c.14,0,.35,0,.35-.21a.54.54,0,0,0-.2-.39,1,1,0,0,0-.44-.16c-2.65-.5-5.21-1.44-7.92-1.69C181.9,101.51,182,101.42,182.21,101.37Z"/>
                    <path class="cls-2" d="M108.08,39.05c-4.1-2.3-4.82-2.15-7.93,1.52a8.91,8.91,0,0,1-5.24,3.33,15.73,15.73,0,0,0-2.69,1.27c-3.85,1.52-7.72,3-11.46,4.71a32.58,32.58,0,0,1-7.16,2,3.45,3.45,0,0,0-1.3.57,6.21,6.21,0,0,1-3.4,1,28.57,28.57,0,0,0-4.53.19c-.7.14-1.41.21-1.79,1-.21.4-.69.34-1.09.31A52.48,52.48,0,0,0,49,55.74c-2,.35-3.8-.27-5.69-.52a44.44,44.44,0,0,1-7.83-1.62,1.62,1.62,0,0,0-.81-.14,6.42,6.42,0,0,1-4.85-.74c-2.8-1.41-6-1.36-8.88-2.66-3.29-1.49-6.8-2.5-10-4.36a18.53,18.53,0,0,1-6.42-6.45,9.24,9.24,0,0,0-2.77-3.06c-2.44-1.63-2.26-4.7-.13-7,.25-.26.6-.43.79-.72s1.59-.36.31-1.1c0,0,0-.17,0-.2.88-.79,1.51-2.05,2.67-2.28a2.26,2.26,0,0,0,2-2c.17-.8.63-1.36,1.51-.9.63.32.79-.22,1.05-.46a35.64,35.64,0,0,1,10.56-7.11c.91-.39,1.88-.64,2.82-1,.6-.22,1.19-.45,1.78-.69,1.16-.47,2-1.58,3.63-1.15,1.22.32,2.41-.85,3.41-1.7.7-.58-.18-.52-.79-.84C40.17,5.64,49,4.63,58,4.83c-1.54.47-3.16.3-4.72.62a10.66,10.66,0,0,1-2.88.33c-.49,0-1.32.27-1.23.83s.73.65,1.5.61c1.36-.06,2.59-1.48,4-.31a18.7,18.7,0,0,1-4.54.94,25.25,25.25,0,0,0-6.84,1.36,15.29,15.29,0,0,1-3.63.86,1.36,1.36,0,0,0-.5.3c-.23.18-.43.45-.32.72s.49.14.73.07A50.12,50.12,0,0,1,47,9.72a83.69,83.69,0,0,1,17.69-.28,71.22,71.22,0,0,1,18.59,3.74,39.72,39.72,0,0,1,9.27,4.39c1.77,1.22,3.69,2.23,5.51,3.37a1.79,1.79,0,0,0,1.68.19,21.54,21.54,0,0,0,7-4.4c3-2.65,5.81-5.59,8.9-8.19A39.57,39.57,0,0,1,130.29.91c.31-.1,1.21.19.94-.8,0-.1.53-.26.84.2a3.27,3.27,0,0,1,.23,2.75,16.5,16.5,0,0,1-3,6.42,21.41,21.41,0,0,1-4.42,4.64c-1,.76-1.27,2.16-2.4,2.83-.11.07-.23.33-.18.41.71,1.36-.55,1.29-1.18,1.73-1,.73-2.35,1-3.2,2.1a1.77,1.77,0,0,0-.57,1.64,2.63,2.63,0,0,1-1.11,2.11c-1.39,1.23-2.54,2.67-3.82,4-.58.61-.38.92.26,1.34,3.54,2.31,7.21,4.42,10.92,6.43,2.53,1.36,5.06,2.72,7.53,4.18.68.4,1.59.1,2,.92.39-.34-.11-1,.57-1.09.51,0,.77.37,1,.72a9.77,9.77,0,0,0,.8,1.18,2.17,2.17,0,0,1,.37,2.63c-.7,1.65-.62,1.78.77,2.91a37.78,37.78,0,0,1,4.73,4,7.08,7.08,0,0,1,1.31,2c.07.18.24.48.18.54a7.53,7.53,0,0,0-1.46,2.82c-.11.26-.43,0-.64,0a8.8,8.8,0,0,1-3.21-1.56c-1.56-1.09-3.34-1.86-4.7-3.26a3.13,3.13,0,0,0-2.35-.7h-3.1c.14-.87.76-.68,1.23-.73.29,0,.61-.07.71-.34s-.23-.39-.38-.55c-.5-.53-.86-1.24-1.85-.64-.54.33-1.06-.37-1.62-.59l1.09-.06a9.6,9.6,0,0,0-2.14-1.83,14,14,0,0,1-4.23-4,4.69,4.69,0,0,0-3.65-2c-3.34-.34-5.93-2.09-8.41-4.13-.71-.58-1.42-1.17-2.47-.56a19.56,19.56,0,0,0,2.66,2.29C108.37,39,108.33,39.15,108.08,39.05Z"/>
                    <path class="cls-3" d="M15.57,128.11c-.19,0-.42.16-.58.11a.83.83,0,0,0-1.17.49c-.21.57.69.19.74.86-2.26-.62-3.59,1-5.22,2a4.25,4.25,0,0,1-.83.46c-.53.14-1,1-1.62.19s-1-1.5-.11-2.4a24.87,24.87,0,0,1,2.79-2.44c.61-.43.87-.92.49-1.61-.57-1,.32-1.6.77-2.3a.37.37,0,0,1,.31-.14c1.12.74,1.84-.24,2.63-.66,3-1.59,6-3.2,8.84-5,.78-.5.75-.89.17-1.45S21.59,115,21,114.44c-.19-.2-.45-.45-.45-.69,0-1.57-1.23-2.18-2.39-2.59-.87-.31-.64-1.09-1-1.59-1.06-1.41-2.61-2.34-3.54-3.87a8.63,8.63,0,0,1-1.64-4c0-.68-.12-1,1-.74,5.15,1.42,9,4.69,12.63,8.34a12.5,12.5,0,0,0,4.1,2.85,1.73,1.73,0,0,0,1.79-.16,41.4,41.4,0,0,1,4.81-2.89,34.27,34.27,0,0,1,8.87-2.72,48.15,48.15,0,0,1,15.48-.24c1.13.18,2.24.45,3.4.52a23,23,0,0,0-6.39-1.75c.07-.38.75-.35.54-.81a.73.73,0,0,0-.83-.35c-.82.16-1.5-.4-2.29-.38a33.09,33.09,0,0,1,9.95,1.17c.65.16,1.3.36,1.94.57.43.15.81.24,1,.87s1,1,1.63,1A21.65,21.65,0,0,1,76,109.39a14.71,14.71,0,0,1,3.85,2.81c.31.3.58.67,1.12.56.15,0,.49.1.51.21.19,1,1.08,1.27,1.78,1.79a10.56,10.56,0,0,1,2.18,3.08,2,2,0,0,1-.73,2.9,4.32,4.32,0,0,0-1.61,1.81,11.11,11.11,0,0,1-5.24,4.36,46.58,46.58,0,0,1-9.71,3.25,66.65,66.65,0,0,1-8.77,1.49,15.13,15.13,0,0,1-2.72-.35,23.81,23.81,0,0,0-4.77-.23,1.15,1.15,0,0,1-1.1-.29,1.43,1.43,0,0,0-1.21-.42c-2.51.31-4.74-.89-7.08-1.38-1.83-.38-3.51-1.45-5.3-2.1s-3.46-1.63-5.29-2.22a5.22,5.22,0,0,1-2.36-2,2.75,2.75,0,0,0-2.44-1.26c-.26.1-.53.2-.51-.26.11-.25.14-.53-.23-.44a2.48,2.48,0,0,0-.93.5,9.7,9.7,0,0,1-4.63,2.24,3.28,3.28,0,0,0-2.4,1.59c-.72,1.14-2.08,1.58-2.93,2.58C15.57,127.8,15.77,127.92,15.57,128.11Z"/>
                    <path class="cls-4" d="M112.11,41.11l3.9,2.22-.06.28H112.7c-.89,0-1.15-.41-.73-1.2A1.36,1.36,0,0,0,112.11,41.11Z"/>
                    <path class="cls-5" d="M120.18,49.46c.72-.55.09-1.79,1.15-2s1.86.51,3,1.06c-.87,0-1.12.66-1.61.95-.26.16-.77.88-.93-.16-.07-.42-.31-.19-.48,0A1,1,0,0,1,120.18,49.46Z"/>
                    <path class="cls-6" d="M136.28,126.94c.94-.53,1.57-.9,2.21-1.25.23-.12.54-.44.71-.22a1.77,1.77,0,0,1,.31,1.1c0,.39-.43.37-.75.37Z"/>
                    <path class="cls-7" d="M131.2,130.13c.65-.16,1.26-1,2-.22.22.21.34,1,.21,1C132.66,130.89,131.67,131.46,131.2,130.13Z"/>
                    <path class="cls-8" d="M21.32,124.57l1.31-.77c.2-.11.43-.31.6,0a1.31,1.31,0,0,1,.18.68c0,.29-.3.31-.55.31H21.34Z"/>
                    <path class="cls-9" d="M16.61,127.43l1-.41c.32-.12.65-.14.83.19a4,4,0,0,1,.22.77,4.23,4.23,0,0,1-1,.16c-.39,0-.57-.54-1-.53-.07,0-.09-.09-.06-.13A.14.14,0,0,1,16.61,127.43Z"/>
                    <path class="cls-10" d="M181.52,99.82c-.63.21-1.33-.16-1.94.25a3.46,3.46,0,0,1-2.14-.36A19.87,19.87,0,0,1,181.52,99.82Z"/>
                    <path class="cls-11" d="M182.21,101.37l-.23.36-2.36-.41C180.58,100.37,181.37,101.35,182.21,101.37Z"/>
                    <path class="cls-12" d="M109.63,39.82A5,5,0,0,1,111.7,41,2.48,2.48,0,0,1,109.63,39.82Z"/>
                    <path class="cls-13" d="M55.26,104.31a1.3,1.3,0,0,1,1.73.28A2.44,2.44,0,0,1,55.26,104.31Z"/>
                    <path class="cls-14" d="M108.08,39.05l.28-.24a2.32,2.32,0,0,1,1.11.86A1.66,1.66,0,0,1,108.08,39.05Z"/>
                    <path class="cls-15" d="M26.63,121.18c.11.21.31.23.51.26l-1,.47c-.25.1-.29,0-.23-.23Z"/>
                    <path class="cls-16" d="M25.93,121.68l.23.23-1,.73A1.23,1.23,0,0,1,25.93,121.68Z"/>
                    <path class="cls-17" d="M142.9,122.88l.26.24a1.62,1.62,0,0,1-1,.57C142.22,123.19,142.58,123.05,142.9,122.88Z"/>
                    <path class="cls-18" d="M16.61,127.43a.57.57,0,0,0,0,.18c-.24.36-.68.33-1,.5.06-.17-.34-.27-.06-.46Z"/>
                    <path class="cls-19" d="M141.21,124.36c0,.15-.15.21-.28.27s-.35.09-.29-.15.2-.21.32-.29S141.17,124.18,141.21,124.36Z"/>
                    <path class="cls-20" d="M130.6,130.65a1.55,1.55,0,0,1-.4.17c-.15,0-.21-.1-.12-.19a1.06,1.06,0,0,1,.4-.19A.86.86,0,0,1,130.6,130.65Z"/>
                    <path class="cls-21" d="M204.28,126.47c-1.09.31-2.07-.36-3.09-.72a12.71,12.71,0,0,1-5.85-3.66,2.76,2.76,0,0,1-.36-1.9,27,27,0,0,1,.74-3.87,4.93,4.93,0,0,1,3-3.35,2.43,2.43,0,0,1,1.39,0c.57.05,1.26,0,.72-.86-.22-.37-.12-.49.22-.59a12,12,0,0,1,3.28-.84c1,0,1.91-.13,2.85-.07s1.72,1.21,2.67,1.47c1.65.44,2.12,1.64,2.52,3,.18.61.48,1.19.64,1.8a2.73,2.73,0,0,1-.49,2.7,9.08,9.08,0,0,0-1.76,2.83C209.61,125.38,207.37,126.52,204.28,126.47Z"/>
                    <path class="cls-22" d="M151.88,112.26c.78-1.26,2-1.65,3.15-2.38A3.75,3.75,0,0,1,151.88,112.26Z"/>
                    <path class="cls-23" d="M162.05,110c1-1,1.87.22,2.74-.11.1,0,.19.21.13.38a.55.55,0,0,1-.54.4A3.69,3.69,0,0,1,162.05,110Z"/>
                    <path class="cls-24" d="M161.1,107a3.68,3.68,0,0,1-2.58,1,5.26,5.26,0,0,1,2.57-1.25.21.21,0,0,1,.07.2Q161.13,107,161.1,107Z"/>
                    <path class="cls-25" d="M161.1,107v-.29a2,2,0,0,1,1.6-.13C162.23,107.18,161.64,107,161.1,107Z"/>
                    <path class="cls-26" d="M166.87,109.87c0-.06-.15-.15-.14-.25,0-.29.25-.22.42-.22s.26.1.25.14C167.36,109.77,167.14,109.77,166.87,109.87Z"/>
                    <path class="cls-21" d="M19.81,43.11c-1.37-.2-2.56-.34-3.74-.54a7,7,0,0,1-5.21-4.15,24.71,24.71,0,0,0-3.38-5.61,3.82,3.82,0,0,1-.43-3.66c.51-1.84,1.6-3.48,1.84-5.41,0-.32.3-.36.52-.39,1.5-.2,2.59-1.17,3.76-2,1.34-1,2.71-1.81,4.32-.51.12.09.25.2.4,0,1-1.23,2-.63,3-.09a12.44,12.44,0,0,0,2.88.74c.64.16,1.38.24.46,1.11-.45.43.07,1.3.72,1.11a4.49,4.49,0,0,1,4.4,1.09,8.33,8.33,0,0,1,2.69,5.06,14.89,14.89,0,0,1,.65,4.23c-.09,1.07.14,2.49-1.23,3.24A7.47,7.47,0,0,0,30,38.84a4.65,4.65,0,0,1-2.66,1.49,4,4,0,0,0-1.29.59A18.66,18.66,0,0,1,19.81,43.11Z"/>
                    <path class="cls-27" d="M94.25,22.47a.47.47,0,0,1-.57.38,1.86,1.86,0,0,1-1.25-.64c-.85-.92-2.3-1.12-2.81-2.42-.08-.2-.32-.42-.05-.62a.44.44,0,0,1,.43,0c1,1.26,2.85,1.42,3.81,2.76A4.63,4.63,0,0,0,94.25,22.47Z"/>
                    <path class="cls-28" d="M78,18.45a4.36,4.36,0,0,0,2,.76c-1,1-2.14,1.08-3.22,1.34a1,1,0,0,1-1-.48.72.72,0,0,1-.15-.78c.13-.24.43-.12.66-.11a5.77,5.77,0,0,1,.71.1C77.56,19.42,78.11,19.43,78,18.45Z"/>
                    <path class="cls-29" d="M78.67,14.65a1.75,1.75,0,0,1,1.49-.15,15.65,15.65,0,0,1,4.34,1.56c.2.09.47.21.38.51s-.39.19-.59.13a7.58,7.58,0,0,1-3-1.27c-.37-.33-.71-.17-1.08-.21A2.11,2.11,0,0,1,78.67,14.65Z"/>
                    <path class="cls-30" d="M71.94,18.72c.45-.22.81-.31,1.15,0a.25.25,0,0,1-.06.4C72.62,19.28,72.29,19.12,71.94,18.72Z"/>
                    <path class="cls-31" d="M88.33,18.5s-.18.15-.23.13a.66.66,0,0,1-.31-.33c-.06-.24.11-.23.28-.17S88.38,18.24,88.33,18.5Z"/>
                    <path class="cls-32" d="M67,19.3l.44.18a1.92,1.92,0,0,1-.4.36s-.25-.15-.29-.27S67,19.46,67,19.3Z"/>
                    <path class="cls-21" d="M74.93,124.51a5.82,5.82,0,0,1-2.73-.72,11,11,0,0,1-4.2-2.61,2,2,0,0,1-.45-1.65,18.55,18.55,0,0,1,.67-3.38c.53-1.73,1.56-2.4,3.44-2.41.25,0,.49,0,.62-.26a3,3,0,0,1,3.51-1.43s.08.08.09.08c2-1.12,3,1.17,4.62,1.4.3,0,.3.32.38.54.17.49.33,1,.53,1.46.64,1.47.88,2.84-.44,4.16a7.36,7.36,0,0,0-1.2,2.19C78.82,124,76.93,124.35,74.93,124.51Z"/>
                    <path class="cls-33" d="M33.47,113.2c.36-1.17,1.53-1.34,2.36-1.94A3.94,3.94,0,0,1,33.47,113.2Z"/>
                    <path class="cls-34" d="M38.5,109.72a4.87,4.87,0,0,1,3.26-1.06C40.66,109,39.73,109.77,38.5,109.72Z"/>
                    <path class="cls-35" d="M41.37,111.31c.69-.85,1.38.17,2.05-.11.14-.06.25.15.22.33a.48.48,0,0,1-.51.4A2.26,2.26,0,0,1,41.37,111.31Z"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'RecursoPeces',
    }
</script>

<style scoped>
    .cls-1 {
        fill: #60ba4d;
    }

    .cls-2 {
        fill: #273779;
    }

    .cls-3 {
        fill: #7491ca;
    }

    .cls-4 {
        fill: #2c3b7c;
    }

    .cls-5 {
        fill: #2d3c7c;
    }

    .cls-6 {
        fill: #67be55;
    }

    .cls-7 {
        fill: #64bc52;
    }

    .cls-8 {
        fill: #7e9ace;
    }

    .cls-9 {
        fill: #829ccf;
    }

    .cls-10 {
        fill: #8bcd7d;
    }

    .cls-11 {
        fill: #85cb77;
    }

    .cls-12 {
        fill: #4c5a90;
    }

    .cls-13 {
        fill: #95acd7;
    }

    .cls-14 {
        fill: #4c598f;
    }

    .cls-15 {
        fill: #829dcf;
    }

    .cls-16 {
        fill: #a9bcde;
    }

    .cls-17 {
        fill: #7ec76f;
    }

    .cls-18 {
        fill: #d4ddee;
    }

    .cls-19 {
        fill: #99d38d;
    }

    .cls-20 {
        fill: #d1ebcc;
    }

    .cls-21 {
        fill: #fefefe;
    }

    .cls-22 {
        fill: #f1f9f0;
    }

    .cls-23 {
        fill: #f8fbf7;
    }

    .cls-24 {
        fill: #f0f8ee;
    }

    .cls-25 {
        fill: #ebf6e9;
    }

    .cls-26 {
        fill: #e6f4e3;
    }

    .cls-27 {
        fill: #f9f9fb;
    }

    .cls-28 {
        fill: #f5f6f8;
    }

    .cls-29 {
        fill: #f2f3f7;
    }

    .cls-30 {
        fill: #f2f2f6;
    }

    .cls-31 {
        fill: #b9bfd3;
    }

    .cls-32 {
        fill: #d2d5e3;
    }

    .cls-33 {
        fill: #eef2f8;
    }

    .cls-34 {
        fill: #e1e8f3;
    }

    .cls-35 {
        fill: #e4eaf4;
    }
</style>
